import { useState, useEffect } from "react";
import { Button, Box, TextField, Autocomplete } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import ProgressCom from "../../components/ProgressCom";
import Detail from "../../main/detail/Detail";
import { rsProgress, rsActiveMenu } from "../../RecoilStates";
import { useRecoilState } from "recoil";
import { UseCompetitors } from "./UseCompetitors";
import useBreakpoints from "../../hooks/useBreakpoints";

export default function EditOneCompetitor() {
  const [msActiveMenu, setMsActiveMenu] = useRecoilState(rsActiveMenu);
  const navigate = useNavigate();
  const location = useLocation();
  const [brand, setBrand] = useState();
  const { updateCompetitor, getCompetitorDataList, validate } =
    UseCompetitors();
  const [progress, setProgress] = useRecoilState(rsProgress);
  const [selectedCompetitor, setSelectedCompetitor] = useState();
  const [comDataRes, setComDataRes] = useState();
  const [model, setModel] = useState(location.state.model);
  const [competArr, setCompetArr] = useState({
    id: model && model.id ? model.id : "",
    competitorID: model && model.competitorID ? model.competitorID : "",
    url: model && model.url ? model.url : "",
    parameter1: model && model.parameter1 ? model.parameter1 : "",
    parameter2: model && model.parameter2 ? model.parameter2 : "",
  });
  const [compet, setCompet] = useState({
    productID: location.state.id != null ? location.state.id : "",
    competitors: [{ competArr }],
  });
  const [errorState, setErrorState] = useState({
    url: false,
    competitorID: false,
  });
  const { isSmall } = useBreakpoints();

  useEffect(() => {
    getCompetitorDataList((competitors) => {
      setComDataRes(competitors);
    });
  }, []);

  useEffect(() => {
    if (comDataRes && model.competitorID) {
      setSelectedCompetitor(
        comDataRes.competitors.find((m) => m.id == model.competitorID)
      );
    }
  }, [comDataRes, model.competitorID]);

  useEffect(() => {
    if (selectedCompetitor) {
      setCompetArr({ ...competArr, competitorID: selectedCompetitor.id });
    }
  }, [selectedCompetitor]);

  useEffect(() => {
    if (competArr) {
      setCompet({
        ...compet,
        competitors: [competArr],
      });
    }
  }, [competArr]);

  return (
    <Detail
      breadChilds={{
        title: "محصولات",
        childs: [
          { name: msActiveMenu.pageTitle, url: "/competitors" },
          {
            name: "ویرایش رقبای محصول",
            url: "/competitors/editcompetitors",
            targetID: location.state.id,
          },
          {
            name: "ویرایش رقیب محصول",
            url: "/competitors/editcompetitors/editOneCompetitor",
          },
        ],
      }}
    >
      {!brand ? (
        <Box display="grid" gridTemplateColumns="repeat(12, 1fr)" gap={3}>
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            {comDataRes && (
              <Autocomplete
                disablePortal
                id="combo-box-demo"
                options={comDataRes ? comDataRes.competitors : []}
                getOptionLabel={(competitors) =>
                  competitors.title ? competitors.title : ""
                }
                value={selectedCompetitor ? selectedCompetitor : ""}
                isOptionEqualToValue={(option, value) =>
                  option.value === value.value
                }
                size="small"
                renderInput={(params) => (
                  <TextField
                    error={errorState.competitorID}
                    {...params}
                    label="رقیب"
                  />
                )}
                renderOption={(props, option) => {
                  return (
                    <li {...props} key={option.id}>
                      {option.title ? option.title : ""}
                    </li>
                  );
                }}
                onChange={(evt, value) => {
                  setSelectedCompetitor(value);
                }}
              />
            )}
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              id="outlined-basic"
              label="پارامتر اول "
              variant="outlined"
              size="small"
              value={competArr.parameter1 ? competArr.parameter1 : ""}
              onChange={(event) => {
                setCompetArr({
                  ...competArr,
                  parameter1: event.target.value,
                });
              }}
              sx={{ width: "100%" }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 3"}>
            <TextField
              size="small"
              id="outlined-basic"
              label="پارامتر دوم "
              value={competArr.parameter2 ? competArr.parameter2 : ""}
              variant="outlined"
              onChange={(event) => {
                setCompetArr({
                  ...competArr,
                  parameter2: event.target.value,
                });
              }}
              sx={{ width: "100%" }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 9"></Box>}
          <Box gridColumn={isSmall ? "span 12" : "span 6"}>
            <TextField
              size="small"
              fullWidth
              error={errorState.url}
              id="outlined-basic"
              label="آدرس وبسایت"
              sx={{
                direction: "initial",
                whiteSpace: "normal",
                input: { direction: "initial" },
              }}
              multiline
              value={competArr.url ? competArr.url : ""}
              variant="outlined"
              onChange={(event) => {
                setCompetArr({
                  ...competArr,
                  url: event.target.value,
                });
              }}
            />
          </Box>
          {!isSmall && <Box gridColumn="span 6"></Box>}
          <Box
            gridColumn={isSmall ? "span 12" : "span 6"}
            sx={{ display: "flex", justifyContent: "flex-end" }}
          >
            <Button
              sx={{ mr: 2, width: "100px" }}
              variant="contained"
              color="secondary"
              onClick={() => {
                setCompet({
                  ...compet,
                  competitors: [competArr],
                });
                if (validate(competArr, setErrorState) == 200) {
                  setProgress(true);
                  updateCompetitor(compet, () => {
                    navigate("/competitors/editcompetitors", {
                      state: { ...location.state, isBack: true },
                      replace: true,
                    });
                  });
                }
              }}
            >
              ثبت
            </Button>
            <Button
              sx={{ width: "100px" }}
              variant="outlined"
              color="secondary"
              onClick={() => {
                navigate("/competitors/editcompetitors", {
                  state: { ...location.state, isBack: true },
                  replace: true,
                });
              }}
            >
              بازگشت
            </Button>
          </Box>
        </Box>
      ) : (
        <ProgressCom></ProgressCom>
      )}
    </Detail>
  );
}
